import React, { useState } from 'react';
import { Button } from 'reactstrap';
import FSBModal from 'components/common/FSBModal';
import SendEmail from './components/SendEmail';

const SendEmailToVendors = ({ rowSelection, resetRowSelection }) => {
  const [showEmailPopup, setShowEmailPopup] = useState(false);

  const drawerToggle = () => {
    setShowEmailPopup(!showEmailPopup);
  };

  return (
    <>
      <FSBModal
        open={showEmailPopup}
        size="xl"
        title="Send Email"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
        onConfirmClick={drawerToggle}
        modalClass="right-drawer right-drawer-details"
      >
        <SendEmail
          rowSelection={rowSelection}
          drawerToggle={drawerToggle}
          resetRowSelection={resetRowSelection}
        />
      </FSBModal>
      <Button
        size="sm"
        outline
        // className="small-btn ms-2"
        className="text-decoration-underline border-0 bg-transparent p-0 me-2 text-primary"
        color="primary"
        onClick={drawerToggle}
        disabled={rowSelection.length === 0}
      >
        Email
      </Button>
    </>
  );
};

export default SendEmailToVendors;
